import { ChatRoom, ChatRoomType } from '@dinosband/bv-main-schema/dist/types'
import { _undefined } from '@dinosband/dbi-utils'

import { HelpDeskChatRoomSubscriber } from '../../subscriber'
import { DataCenter_StoreType } from '../abstract'
import { CHAT_ROOM_ADDED } from './const'

export class HelpDeskChatRooms extends DataCenter_StoreType<number, ChatRoom> {

  private _subscriber?: HelpDeskChatRoomSubscriber

  async init () {
    this._subscriber = new HelpDeskChatRoomSubscriber(this.context, (value) => this.onChatRoomAdded(value))
    await this._subscriber.start()
  }

  cleanup () {
    super.cleanup()
    this._subscriber?.cleanup()
    this._subscriber = _undefined()
  }

  get chatRooms () {
    return this.values
  }

  onReconnected () {
    this._subscriber?.retrieve()
  }

  async requestChatRoom (channelId: number, profileId: number) {
    const chatRoom = await this.mainStore.createHelpDeskChatRoom(channelId, profileId)
    if (chatRoom) {
      this.onChatRoomAdded(chatRoom)
    }
    return chatRoom
  }

  private onChatRoomAdded (value: ChatRoom | ChatRoom[]) {
    const chatRooms = value instanceof Array ? value : [value]
    chatRooms.forEach((i) => this.set(i.id, i))
    this.pubsub.publish(CHAT_ROOM_ADDED, {
      type: ChatRoomType.HELPDESK,
      chatRooms,
    })
  }

}
